import { createQueryHook } from 'swr-openapi';

import { backendClient } from '@/api/backendClient';

export const useBackend = createQueryHook(backendClient, 'v2');
